var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmotionTired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0663 11.1727C34.7297 10.9002 39.6928 15.0232 43.0243 19.92C43.5033 20.6236 43.9473 21.3511 44.3547 22.0996C44.5698 22.4955 44.7778 22.8987 44.9822 23.302C47.4925 28.2423 49.3106 33.7384 47.575 39.3181C44.7922 48.2652 35.5832 50.0234 24.9828 50.1469C23.133 50.1701 21.2883 49.9465 19.4961 49.4821C17.8545 49.0769 16.2877 48.4073 14.8557 47.4987C12.997 46.2911 11.4445 44.6579 10.3233 42.7309C9.20207 40.8038 8.54355 38.6369 8.40083 36.4047C8.00636 31.2755 9.51968 27.7083 11.7394 23.0186C13.5755 19.1353 17.4305 14.6636 21.9777 12.5022C23.5671 11.7135 25.2985 11.2611 27.0663 11.1727Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5758 39.3256C44.793 48.2727 31.4385 51.5238 20.2679 49.6748",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2972 14.01C39.5614 15.5936 41.5083 17.5979 43.0349 19.9166C43.5139 20.6203 43.958 21.3477 44.3654 22.0962",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4261 11.5796C25.288 11.3436 26.1734 11.2071 27.0655 11.1728C29.6085 11.0509 32.1467 11.4987 34.4994 12.4841",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8597 24.6934C12.9181 20.1599 16.185 15.7972 20.7931 13.1272",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0244 48.6505C14.2416 47.8114 11.6453 45.3485 10.9281 43.6375",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.275 29.5246C30.9926 28.8985 30.5355 28.3672 29.9585 27.9945C29.3816 27.6218 28.7093 27.4236 28.0225 27.4236C27.3356 27.4236 26.6633 27.6218 26.0864 27.9945C25.5094 28.3672 25.0523 28.8985 24.7699 29.5246C25.2899 30.9303 26.5629 32.5656 28.0225 32.5656C29.482 32.5656 30.7586 30.9303 31.275 29.5246Z",
    fill: "#FFAFA7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2388 25.0922C33.2388 25.0922 32.0482 25.8274 31.1625 24.4503",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9052 24.5327C24.9052 24.5327 24.2418 25.7591 22.7894 25.0132",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6691 43.8416C15.0055 43.6463 14.4031 43.2839 13.9196 42.7892C13.4361 42.2944 13.0878 41.6838 12.9078 41.0158C12.8314 40.7487 12.6913 40.504 12.4996 40.3029C12.3078 40.1018 12.0701 39.9502 11.8069 39.8611C11.228 39.6612 10.7027 39.3309 10.2718 38.8956C9.8409 38.4603 9.51584 37.9318 9.32176 37.3509C8.73365 35.8017 10.8207 32.4918 12.2552 33.3237C15.124 34.9769 17.3581 38.4805 18.3981 40.4958C19.1404 41.9446 17.2075 44.3796 15.6691 43.8416Z",
    fill: "#CFCFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6482 39.1438C8.98789 38.3908 8.20972 33.9978 9.93103 28.8913C10.0312 28.5273 10.2122 28.1905 10.4606 27.9062C10.7089 27.6218 11.0182 27.3971 11.3655 27.2489C12.1938 26.9405 13.1298 27.2058 13.9044 27.5609C16.4361 28.7156 18.1826 30.7345 19.2297 33.277C20.0294 35.2243 20.3521 37.5552 21.0837 39.4594C21.4997 40.5496 21.9611 41.6086 22.4679 42.6366C22.5931 42.8862 22.6476 43.1652 22.6257 43.4435C22.6039 43.7857 22.4602 44.1087 22.2208 44.3541C21.9813 44.5995 21.6619 44.751 21.3204 44.7811C20.5195 44.871 19.7113 44.6972 19.0181 44.2862C17.2753 43.257 16.2031 41.5752 16.7983 38.4625",
    fill: "#CFCFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6482 39.1438C8.98789 38.3908 8.20972 33.9978 9.93103 28.8913C10.0312 28.5273 10.2122 28.1905 10.4606 27.9062C10.7089 27.6218 11.0182 27.3971 11.3655 27.2489C12.1938 26.9405 13.1298 27.2058 13.9044 27.5609C16.4361 28.7156 18.1826 30.7345 19.2297 33.277C20.0294 35.2243 20.3521 37.5552 21.0837 39.4594C21.4997 40.5496 21.9611 41.6086 22.4679 42.6366C22.5931 42.8862 22.6476 43.1652 22.6257 43.4435C22.6039 43.7857 22.4602 44.1087 22.2208 44.3541C21.9813 44.5995 21.6619 44.751 21.3204 44.7811C20.5195 44.871 19.7113 44.6972 19.0181 44.2862C17.2753 43.257 16.2031 41.5752 16.7983 38.4625",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.771 43.1565C14.2079 42.9489 13.7222 42.5734 13.3796 42.0807C12.4938 40.7933 12.5261 38.2723 13.4943 36.1816",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.014 10.6239V13.1019",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8265 6.27393V11.3339",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3617 7.99194V12.869",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.598 5.82581V8.30378",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22584 12.8688L6.7699 14.6977L8.22584 16.5301L6.7699 18.3626",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2281 10.1218L48.7758 11.9507L50.2281 13.7832L48.7758 15.6157",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3967 21.6536C37.0668 22.2345 36.719 22.8872 36.719 23.2601C36.71 23.426 36.7349 23.5921 36.7922 23.748C36.8495 23.904 36.938 24.0466 37.0522 24.1673C37.1665 24.2879 37.3042 24.384 37.4568 24.4496C37.6094 24.5153 37.7738 24.5492 37.94 24.5492C38.1062 24.5492 38.2706 24.5153 38.4232 24.4496C38.5759 24.384 38.7135 24.2879 38.8278 24.1673C38.9421 24.0466 39.0305 23.904 39.0878 23.748C39.1451 23.5921 39.1701 23.426 39.1611 23.2601C39.154 23.0075 39.1093 22.7573 39.0284 22.5178",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7906 27.5895C36.5666 28.2452 36.5149 28.9474 36.6405 29.6287C36.7661 30.3101 37.0648 30.9477 37.5078 31.4804C37.6852 31.6977 37.8064 31.9552 37.8608 32.2304C37.9152 32.5055 37.9011 32.7899 37.8198 33.0583C37.6463 33.645 37.6097 34.2637 37.7129 34.8668C37.8161 35.4698 38.0563 36.0411 38.4151 36.5368C39.3367 37.9138 43.5467 37.9317 43.7045 36.2821C44.0165 32.9973 42.1661 29.3395 41.119 27.317C40.3515 25.8754 37.2496 26.0224 36.7906 27.5895Z",
    fill: "#CFCFFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.687 34.4066C37.3284 36.1997 40.459 39.3841 45.6158 40.9512C45.9673 41.079 46.3429 41.1267 46.7152 41.0907C47.0874 41.0547 47.4469 40.936 47.7674 40.7432C48.5026 40.2483 48.8433 39.3339 48.9903 38.4947C49.521 35.7622 48.8935 33.173 47.4304 30.8421C46.3151 29.0491 44.6045 27.4389 43.4857 25.7427C42.8438 24.7673 42.2449 23.7775 41.6927 22.7699C41.5645 22.5195 41.3681 22.3107 41.1261 22.1674C40.8347 21.9866 40.4883 21.9162 40.1495 21.9688C39.8107 22.0214 39.502 22.1936 39.2792 22.4543C38.7441 23.0519 38.417 23.8068 38.3469 24.6059C38.1711 26.6249 38.917 28.4753 41.7967 29.7985",
    fill: "#CFCFFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.687 34.4066C37.3284 36.1997 40.459 39.3841 45.6158 40.9512C45.9673 41.079 46.3429 41.1267 46.7152 41.0907C47.0874 41.0547 47.4469 40.936 47.7674 40.7432C48.5026 40.2483 48.8433 39.3339 48.9903 38.4947C49.521 35.7622 48.8935 33.173 47.4304 30.8421C46.3151 29.0491 44.6045 27.4389 43.4857 25.7427C42.8438 24.7673 42.2449 23.7775 41.6927 22.7699C41.5645 22.5195 41.3681 22.3107 41.1261 22.1674C40.8347 21.9866 40.4883 21.9162 40.1495 21.9688C39.8107 22.0214 39.502 22.1936 39.2792 22.4543C38.7441 23.0519 38.417 23.8068 38.3469 24.6059C38.1711 26.6249 38.917 28.4753 41.7967 29.7985",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8191 28.7227C36.6621 29.3002 36.6846 29.9119 36.8836 30.4763C37.4215 31.9466 39.4907 33.3846 41.7571 33.8113",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6442 10.3049C28.3615 13.0195 30.8071 14.7301 33.0233 14.5257C33.07 13.4283 33.0986 10.8177 30.8466 9.28644C30.0659 8.73338 29.1621 8.37901 28.2135 8.25403C27.265 8.12906 26.3003 8.23725 25.403 8.56923",
    fill: "#FFF8F2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6442 10.3049C28.3615 13.0195 30.8071 14.7301 33.0233 14.5257C33.07 13.4283 33.0986 10.8177 30.8466 9.28644C30.0659 8.73338 29.1621 8.37901 28.2135 8.25403C27.265 8.12906 26.3003 8.23725 25.403 8.56923",
    stroke: "#868686",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionTired);
export default __webpack_public_path__ + "static/media/EmotionTired.5be7308fb15f4fef161195b965998c02.svg";
export { ForwardRef as ReactComponent };